import '../../App.css'
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { signal } from "@preact/signals-react";
import TableRow from '../TableRow';
import MobileTableRow from '../mobileTableRow';
import SkyLoader from '../../components/sky-loader'
import { useSelector } from 'react-redux';

export const eventId = signal("");
function Soccer() {
    const userInfos = useSelector((state) => state.events); // Use selector to access state
    const [events, setEvents] = useState([])
    const [allEvents, setAllEvents] = useState([])

    useEffect(() => {
        if (userInfos?.events?.length) {
            setAllEvents(userInfos.events[0]?.competitions[0].events)
        }
    }, [userInfos?.events])

    useEffect(() => {
        if (allEvents.length > 0) {
            const tempEvents = allEvents.filter(event => event.event_type == 1)
            // const inPlay = allEvents.filter(event => event.is_inplay == 'True')
            setEvents(tempEvents)
        }
    }, [allEvents])
    
    return (
        <>
            {/* Desktop */}
            {!events.length > 0 && (
                <SkyLoader />
            )}
            {events.length > 0 && (
                <table className="hidden lg:inline-table w-full">
                    <thead className="#dddcd6 bg-[#dddcd6] ">
                        <tr>
                            <th scope="col" className="text-[0.688rem] "></th>
                            <th scope="col" className="text-[0.688rem] ">1</th>
                            <th scope="col" className="text-[0.688rem] ">X</th>
                            <th scope="col" className="text-[0.688rem] ">2</th>
                            <th scope="col" className="text-[0.688rem] "></th>
                        </tr>
                    </thead>
                    <tbody className='bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]'>
                        {events.map((event, index) => (
                            <TableRow key={index} row={event} />
                        ))}
                    </tbody>
                </table>
            )}
            {/* Mobile */}
            {events.length > 0 && (
                <table className="lg:hidden w-full">
                    <tbody className='bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]'>
                        {events.map((event, index) => (
                            <MobileTableRow key={index} row={event} />
                        ))}

                    </tbody>
                </table>
            )}
        </>
    );
}

export default Soccer;
